module.exports = __webpack_public_path__ + "static/media/reacondicionamiento termico viviendas.6abb1271.jpg";